import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import { CUSTOM_EVENT } from '../config';

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$container = this.$('container')[0]
        this.$prevButton = this.$('prev')[0]
        this.$nextButton = this.$('next')[0]

        // Data
        this.length = this.$('item').length
    }

    //////////////
    // Lifecycle
    //////////////
    init() {

        Swiper.use([ Navigation, A11y ])

        const args = {
            speed: 700,
            a11y: true,
            loop: false,
            spaceBetween: 20,
            grabCursor: true,
            slidesPerView: 1.1,
            navigation: {
                prevEl: this.$prevButton,
                nextEl: this.$nextButton,
            },
            breakpoints: {
                700 : {
                    slidesPerView: 2.1,
                },
                1200 : {
                    slidesPerView: 3,
                }
            }
        }

        this.carousel = new Swiper(this.$container, args)
    }

    destroy() {
        super.destroy()
        this.carousel?.destroy(true, true)
    }
}
